import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { isMobile, isTablet } from 'react-device-detect';
import { initBlock, resetBlock, goToPage, setActivateEsimStep, setActivateEsimMinStep } from './EsimQrCodeBlockSlice';
import { prepareBlockAsync, navigateEsimQrBack } from './EsimQrCodeBlockAsyncThunk';
import { GetUserDetails } from 'app/Components/Block/IdfSaleBlock/IdfSaleSlice';
import { clearStateHistoryAction } from '../../../utilities/stateHistory/stateHistorySlice';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import EsimBackButton from './Partials/EsimBackButton/EsimBackButton';
import InstructionsPage from './Pages/InstructionsPage/InstructionsPage';
import ActivationCodesPage from './Pages/ActivationCodesPage/ActivationCodesPage';
import VideoPage from './Pages/VideoPage/VideoPage';
import WhatsAppSuccessPage from './Pages/WhatsAppSuccessPage/WhatsAppSuccessPage';
import ErrorPage from './Pages/ErrorPage/ErrorPage';
import ActivateEsimPage from './Pages/ActivateEsimPage/ActivateEsimPage';
import InstallEsimOnMobilePage from './Pages/InstallEsimOnMobilePage/InstallEsimOnMobilePage';
import './EsimQrCodeBlock.scss';

const DEVICE_SELECTION_STEP = 0;

const getInitialActivateEsimStep = () => (isMobile || isTablet ? DEVICE_SELECTION_STEP : 1);

const isQrCodeRefreshRestore = (page) => {
    if (typeof window === 'undefined' || !page) {
        return false;
    }
    const hashPage = window.location.hash.replace(/^#\/?/i, '').toLowerCase();
    return hashPage.length > 0 && hashPage === page.toLowerCase();
};

const EsimQrCodeBlock = (props) => {
    let currentView = null;

    useEffect(() => {
        const isRestoredFlow = isQrCodeRefreshRestore(props.page);
        const initialStep = getInitialActivateEsimStep();

        if (isRestoredFlow) {
            props.initBlock({ esimQrCodeBlock: props.iContent, preservePage: true });
            props.setActivateEsimMinStep(initialStep);
        } else {
            props.clearStateHistoryAction();
            window.history.replaceState(null, '', window.location.pathname + window.location.search);
            props.resetBlock();
            props.initBlock({ esimQrCodeBlock: props.iContent });
            props.setActivateEsimMinStep(initialStep);
            props.setActivateEsimStep(initialStep);
        }

        return () => {
            props.resetBlock();
        };
    }, []);

    useEffect(() => {
        init();
    }, [props.authentication.isAuthenticateFinish]);

    const init = async () => {
        if (props.authentication.isAuthenticateFinish) {
            const isIdfCustomer = props.authentication.loginData.userDetails.RoleList.some(role => role.startsWith('IDFOTP')) ?? false;
            if (!isNullOrEmpty(props.idfStore.userDetails)) {
                await props.GetUserDetails();
            }
            props.prepareBlockAsync(isIdfCustomer);
        }
    };

    const handleSetActivateEsimStep = (step) => props.setActivateEsimStep(step);

    switch (props.page) {
        case 'activateEsimPage':
            currentView = (
                <ActivateEsimPage
                    step={props.activateEsimStep}
                    setStep={handleSetActivateEsimStep}
                />
            );
            break;
        case 'installEsimOnMobilePage': currentView = <InstallEsimOnMobilePage />; break;
        case 'instructionsPage': currentView = <InstructionsPage />; break;
        case 'activationCodesPage': currentView = <ActivationCodesPage />; break;
        case 'videoPage': currentView = <VideoPage />; break;
        case 'whatsAppSuccessPage': currentView = <WhatsAppSuccessPage />; break;
        case 'errorPage': currentView = <ErrorPage />; break;
    }

    return (
        <form noValidate id='esim-qr-code-block' onSubmit={handleSubmit}>
            {props.page && <EsimBackButton onClick={() => props.navigateEsimQrBack()} />}
            {currentView}
        </form>
    );

    function handleSubmit(event) {
        event.preventDefault();
    }
};

const mapStateToProps = (state) => {
    return {
        page: state.esimQrCodeBlock.page,
        activateEsimStep: state.esimQrCodeBlock.activateEsimStep,
        authentication: state.authentication,
        headerRemark: state.esimQrCodeBlock.esimBlockData.headerRemark,
        idfStore: state.idfSale,
    };
};

const mapDispatchToProps = {
    initBlock,
    resetBlock,
    prepareBlockAsync,
    GetUserDetails,
    clearStateHistoryAction,
    setActivateEsimStep,
    setActivateEsimMinStep,
    goToPage,
    navigateEsimQrBack,
};

export default connect(mapStateToProps, mapDispatchToProps)(EsimQrCodeBlock);
